/**
 * 产品 KPI 的数据请求（TanStack Query）：指标列表 + 每个指标的 30 天、90 天序列，
 * 接口与参数与旧版 useProductKpi 一致
 */
import { useQuery } from '@tanstack/react-query'
import { metricsApi, type MetricRange } from '@/api/metrics'

export const PRODUCT_KPI_KEY = ['admin', 'product-kpi'] as const

export interface KpiMetric {
  name: string
  definition: string
}

export function useKpiMetrics() {
  return useQuery({
    queryKey: [...PRODUCT_KPI_KEY, 'list'],
    queryFn: async (): Promise<KpiMetric[]> => {
      const list = (await metricsApi.listDashboard()).data?.data ?? {}
      return Object.entries(list).map(([name, info]) => ({ name, definition: info.definition }))
    }
  })
}

export function useKpiSeries(metricName: string, range: MetricRange) {
  return useQuery({
    queryKey: [...PRODUCT_KPI_KEY, 'series', metricName, range],
    queryFn: async () => (await metricsApi.getSeries(metricName, range)).data?.data ?? null
  })
}
